<template>
    <!-- .wrapper -->
    <div class="page has-sidebar has-sidebar-fixed has-sidebar-expand-xl">
      <!-- .page-inner -->
      <div class="page-inner page-inner-fill">
        <nav class="page-navs pr-3" :class="{'he' : isMobile}">
          <div class="btn-group">
            <button id="calendar-prev" class="btn btn-secondary" @click="prev"><em class="fa fa-chevron-left"></em></button>
            <button id="calendar-today" class="btn btn-secondary" @click="today">Today</button>
            <button id="calendar-next" class="btn btn-secondary" @click="next"><em class="fa fa-chevron-right"></em></button>
          </div>
          <div class="ml-auto">
              <router-link to="/time-recording-list" class="btn btn-primary ml-2 mt-2 mb-1" tag="button" v-show="action_button.approval_list">Supervision</router-link>
              <button type="button" class="btn btn-success ml-2" @click="submitTimeRecording" v-show="action_button.submit">Submit Time Recording</button>
          </div>

        </nav><!-- /.page-navs -->
        <div class="board">
          <div class="card">
            <div class="calendar">
              <full-calendar class="full-calendar"  ref="calendar"  :options="config">
                <template #eventContent="{ timeText, event }">
                  <div style="padding-left:10px" v-if="event.id !== ''">
                    <div class="fc-daygrid-event-dot"></div>
                    <strong>{{ timeText }}</strong>
                    <em style="white-space: break-spaces;">
                      {{event.extendedProps.duration_hours !== undefined  && event.extendedProps.duration_hours  > 0? event.extendedProps.duration_hours+"h": ""}}{{event.extendedProps.duration_minutes !== undefined && event.extendedProps.duration_minutes> 0? event.extendedProps.duration_minutes+"m" :""}}#{{ event.title }}, {{event.extendedProps.time}} hours
                    </em>
                  </div>
                  <div style="padding-left:10px" v-else>

                  </div>
                </template>
              </full-calendar>
            </div>
          </div>
        </div>
        <calendar-sidebar :events="events" :weekends-visible="weekendsVisible"
                          @set-weekends-visible="setweekendsVisible"/>
      </div><!-- /.page-inner -->
      <b-modal id="modal-prevent-closing" ref="modal" title="Input"  @hidden="resetModal" @ok="handleOk" ok-title="Save">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <b-form-group  label="Check In">
                <b-input-group class="mb-3">
                  <b-form-input id="check-in" v-model="data.check_in" type="text" placeholder="HH:mm"></b-form-input>
                  <b-input-group-append>
                    <b-form-timepicker v-model="data.check_in" button-only now-button reset-button  :hour12="false"  aria-controls="check-in"></b-form-timepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group  label="Check Out">
                <b-input-group class="mb-3">
                  <b-form-input id="check-out" v-model="data.check_out" type="text" placeholder="HH:mm"></b-form-input>
                  <b-input-group-append>
                    <b-form-timepicker v-model="data.check_out" button-only now-button reset-button :hour12="false"  aria-controls="check-out"></b-form-timepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <a v-b-toggle href="#collapse-input" @click.prevent>Add Time Recording Detail</a>
          <b-collapse id="collapse-input" class="mt-2">
            <b-form-group label="Hours" invalid-feedback="Hours is required">
              <v-select v-model="data.hours" :options="option_hours" :reduce="hours=>hours.value" label="text" ></v-select>
            </b-form-group>
            <b-form-group label="Project" invalid-feedback="Project is required" v-if="this.$store.getters.isMultiple">
              <v-select v-model="data.project" :options="option_project" :reduce="hours=>hours.id" label="name" ></v-select>
            </b-form-group>
            <b-form-group label="Location" invalid-feedback="Location is required">
              <b-input-group class="mb-3">
                <b-form-input  v-model="data.location" type="text"></b-form-input>
                <b-input-group-append>
                  <b-button @click="locateMe"><em class="fa fa-map-marker-alt"></em> </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label="Remark" :state="remarkState" for="remark" invalid-feedback="Remark is required">
              <b-form-textarea id="remark" :state="remarkState" required v-model="data.remark"
                               placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
          </b-collapse>
        </form>
      </b-modal>
      <b-modal id="modal-update" ref="modal-update" title="Update"  @hidden="resetModal"
               @ok="handleUpdate">
        <form ref="form" @submit.stop.prevent="updateTimeRecording">
          <div class="row">
            <div class="col-md-6">
              <b-form-group  label="Check In">
                <b-input-group class="mb-3">
                  <b-form-input id="check-in-edit" v-model="data.check_in" type="text" placeholder="HH:mm"></b-form-input>
                  <b-input-group-append>
                    <b-form-timepicker v-model="data.check_in" button-only now-button reset-button  :hour12="false"  aria-controls="check-in-edit"></b-form-timepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group  label="Check Out">
                <b-input-group class="mb-3">
                  <b-form-input id="check-out-edit" v-model="data.check_out" type="text" placeholder="HH:mm"></b-form-input>
                  <b-input-group-append>
                    <b-form-timepicker v-model="data.check_out" button-only now-button reset-button :hour12="false"  aria-controls="check-out-edit"></b-form-timepicker>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <a v-b-toggle href="#collapse-edit" @click.prevent>Add Time Recording Detail</a>
          <b-collapse id="collapse-edit" class="mt-2">
            <b-form-group label="Hours" invalid-feedback="Hours is required">
              <v-select v-model="data.hours" :options="option_hours" :reduce="hours=>hours.value" label="text" ></v-select>
            </b-form-group>
            <b-form-group label="Project" invalid-feedback="Project is required" v-if="this.$store.getters.isMultiple">
              <v-select v-model="data.project" :options="option_project" :reduce="hours=>hours.id" label="name" ></v-select>
            </b-form-group>
            <b-form-group label="Location" invalid-feedback="Location is required">
              <b-input-group class="mb-3">
                <b-form-input  v-model="data.location" type="text"></b-form-input>
                <b-input-group-append>
                  <b-button @click="locateMe"><em class="fa fa-map-marker-alt"></em> </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label="Remark" :state="remarkState" for="remarks" invalid-feedback="Remark is required">
              <b-form-textarea id="remarks" :state="remarkState" required v-model="data.remark"
                               placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>
            </b-form-group>
          </b-collapse>

        </form>
        <template v-slot:modal-footer>
          <div class="w-100">
            <button class="btn btn-primary float-right ml-1" @click="updateTimeRecording"> Save </button>
            <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
          </div>
        </template>
      </b-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import {BButton, BFormGroup, BFormTextarea, BModal, VBModal, BFormInput, BFormTimepicker, BInputGroup, BInputGroupAppend, BCollapse, VBToggle} from "bootstrap-vue"
import vSelect from "vue-select"

import CalendarSidebar from "./CalendarSidebar";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api"
import Acl from "../../../../libs/AclButton";

export default {
  name: "TimeRecording",
  components: {
    FullCalendar,
    CalendarSidebar,
    'b-modal': BModal,
    'b-button': BButton,
    BFormGroup,
    BFormTextarea,
    vSelect,
    BFormInput,
    BFormTimepicker,
    BInputGroupAppend,
    BInputGroup,
    BCollapse
  },
  directives: {
    'b-modal': VBModal,
    'b-toggle':VBToggle
  },
  data() {
    return {
      data: {
        check_in:"",
        check_out:"",
        remark: "",
        hours: 8,
        location :'',
        project: 0,
        date:""
      },
      payload: null,
      option_hours: [],
      remarkState: null,
      option_project: [],
      isMobile:false,
      haveAccess:[],
      detail:{},
      action_button:{
        add:false,
        edit:false,
        submit:false,
        'approval-list':false
      }
    }
  },
  computed: {
    ...mapGetters(['events', 'weekendsVisible']),
    config() {
      return {
        ...this.configOptions,
        ...this.eventHandlers
      }
    },
    configOptions() {
      return {
        editable: false,
        selectable: false,
        selectMirror: true,
        dayMaxEvents: true,
        droppable:true,
        navLinks: true,
        events: this.events,
        weekends: this.weekendsVisible,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        headerToolbar: {
          left: 'title',
          right: 'dayGridMonth'
        },
        initialView: 'dayGridMonth',
        buttonText: {
          month: "Month"
        },
      }
    },
    eventHandlers() {
      return {
        dateClick: this.onDateClick,
        eventClick: this.onEventClick,
        eventDrop: this.onEventDrop,
        eventResize: this.onEventDrop,
        select: this.onDateSelect
      }
    }
  },
  watch:{
    data:{
      check_in(val){
        let arrVal = val.split(':')
        this.data.check_in =  arrVal[0]+':'+arrVal[1]
      }
    }
  },
  methods: {
    ...mapActions([
      'createEvent',
      'updateEvent',
      'deleteEvent',
      'setweekendsVisible'
    ]),
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.remarkState = valid
      return valid
    },
    onDateClick(payload) {
      if(this.checkStatus() && this.action_button.add){
        if(!this.haveAccess.includes(payload.date.getDay()) ){
          this.payload = payload
          this.data.hours = 8
          this.$refs['modal'].show()
        }
      }
    },
    checkStatus(){
      if(Object.keys(this.detail).length > 1){
        if(this.detail.stat_id == 0 ){
          return true
        }
        return false
      }else{
        return true
      }

    },
    handleSubmit() {

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      let diff = this.timeDiff()

      let title = this.data.remark
      const id = (this.events.length + 1) * 10
      const {start, end, date, allDay, dateStr} = this.payload
      let time = this.data.hours
      let project = this.data.project,
          extendedProps = {
            check_in : this.data.check_in,
            check_out : this.data.check_out,
            duration_hours : Math.floor((diff % 86400000) / 3600000),
            duration_minutes:Math.round(((diff % 86400000) % 3600000) / 60000),
            location : this.data.location
          }

      let payload = {
        emp_id:this.$store.getters.empId,
        date:dateStr,
        time:this.data.hours,
        check_in:this.data.check_in,
        check_out:this.data.check_out,
        location:this.data.location,
        project_id:project,
        remarks:this.data.remark,
        user_id:this.$store.getters.userId,
      }
      let backgroundColor = '#fff'
      let textColor = '#363642'
      let borderColor = '#fff'

      AxiosCall.Post(payload, urlApi.time_recording.add_data).then(res =>{
        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs['modal'].hide()
        })
        this.successMessage(res.message)

        this.payload = null
        this.data.remark = ""
        this.data.hours = 8
        this.remarkState = null
        let event = {
          id,
          title,
          date,
          start,
          end,
          allDay,
          time,
          project,
          extendedProps, backgroundColor, textColor, borderColor
        }

        return this.createEvent(event)
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleUpdate(bvModalEvt){
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.updateTimeRecording()
    },
    onDateSelect(payload) {
      return this.onDateClick(payload)
    },
    resetModal() {
      this.data.hours=""
      this.data.project=""
      this.data.remark=""
      this.data.check_in=""
      this.data.check_out=""
      this.data.location=""
      this.$refs['modal-update'].hide()
    },
    onEventClick({event}) {
      if(this.checkStatus() && this.action_button.edit){
        if(event.id !== ""){
          let dtObj = this.events.find(dt=> dt.id==event.id)

          this.payload = event
          this.data.date = event.date
          this.data.hours = dtObj.time
          this.data.project = dtObj.project
          this.data.remark = dtObj.title
          this.data.check_in = dtObj.extendedProps.check_in
          this.data.check_out = dtObj.extendedProps.check_out
          this.data.duration = dtObj.extendedProps.duration
          this.data.location = dtObj.extendedProps.location
          if(dtObj.extendedProps.leave_id == null) this.$refs['modal-update'].show()
        }
      }

    },
    updateTimeRecording(){
      if (!this.checkFormValidity()) {
        return
      }
      let dtObj = this.$store.state.events.find(dt=> dt.id==this.payload.id)
      let title = this.data.remark
      let id = this.payload.id
      let date = dtObj.date
      let start = dtObj.date
      let end = dtObj.date
      let time = this.data.hours
      let project = this.data.project
      let allDay = true
      let diff = this.timeDiff()

      let extendedProps = {
        check_in : this.data.check_in,
        check_out : this.data.check_out,
        duration_hours : Math.floor((diff % 86400000) / 3600000),
        duration_minutes:Math.round(((diff % 86400000) % 3600000) / 60000),
        location : this.data.location
      }

      let payload = {
        emp_id:this.$store.getters.empId,
        date:this.formatDate(dtObj.date),
        time:this.data.hours,
        project_id:this.data.project,
        remarks:this.data.remark,
        check_in:this.data.check_in,
        check_out:this.data.check_out,
        location:this.data.location,
        time_id: this.payload.id
      }

      let backgroundColor = '#fff'
      let textColor = '#363642'
      let borderColor = '#fff'
      let event = {id, title, date, start, end, allDay, time, project,extendedProps, backgroundColor, textColor, borderColor}

      AxiosCall.Put(payload, urlApi.time_recording.update_data).then(async res=>{
        this.successMessage(res.message)
        this.$refs['modal-update'].hide()
        return this.updateEvent(event)

      }).catch(err =>{
        console.log(err)
        this.errorMessage(err.response.data.message)
      })
    },
    submitTimeRecording(){
      let calendarApi = this.$refs.calendar.getApi()
      let date = calendarApi.getDate()
      let firstDay = this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
      let lastDay = this.formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
      this.$router.push({name:"SubmitTimeRecording", params:{first:firstDay, last:lastDay}})
    },
    deleteTimeRecord(){
      AxiosCall.Delete(urlApi.time_recording.delete_data+"/"+this.payload.id).then(res=>{
        this.successMessage(res.message)
        this.$refs["modal-update"].hide()
        return this.deleteEvent(this.payload.id)
      }).catch(err =>{
        this.errorMessage(err.message)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    onEventDrop({event}) {
      return this.updateEvent(event)
    },
    next() {
      let calendarApi = this.$refs.calendar.getApi()
      calendarApi.next()
      this.getData()
      this.getProject()
    },
    prev() {
      let calendarApi = this.$refs.calendar.getApi()
      calendarApi.prev()
      this.getData()
      this.getProject()
    },
    today() {
      let calendarApi = this.$refs.calendar.getApi()
      calendarApi.today()
      this.getData()
      this.getProject()
    },
    getData(){

      this.$store.state.events = []

      let calendarApi = this.$refs.calendar.getApi()
      let date = calendarApi.getDate()
      let firstDay = this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
      let lastDay = this.formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
      let payload = {emp_id: this.$store.getters.empId, start_date: firstDay, end_date: lastDay, lang: "en", company_id: "1"}


      AxiosCall.Get(payload, urlApi.time_recording.get_data).then(res => {
        if (res.success){
          this.getDetail(firstDay)
          for (let data of res.atributes) {

            if (data.remarks !== null ){
              date =new Date(this.formatDate(data.date))
              let id = data.time_id
              let title = data.remarks
              let project = data.project_id
              let start = undefined
              let end = undefined
              let allDay = true
              let time = data.time
              let extendedProps = {
                check_in : data.time_checkin,
                check_out : data.time_checkout,
                duration_hours : data.duration_hours,
                duration_minutes: data.duration_minutes,
                location : data.location,
                leave_id : data.leave_id
              }
              let backgroundColor = '#fff'
              let textColor = '#363642'
              let borderColor = '#fff'

              this.createEvent({id, title, date, start, end, allDay, time, project, extendedProps, backgroundColor, textColor, borderColor})

            }else{
              if(data.weekend == 1){
                date =new Date(this.formatDate(data.date))
                let id = ""
                let title = ""
                let project = ""
                let start = undefined
                let end = undefined
                let allDay = true
                let time = ""
                let display = 'background'
                let backgroundColor = '#b8d9e7'
                let weekend = true
                this.createEvent({id, title, date, start, end, allDay, time, project, display, backgroundColor, weekend})
              }

            }
          }
        }else{
          this.errorMessage(res.message)
        }

      }).catch(e=>{
        console.log(e)
      })
    },
    getProject(){
      let calendarApi = this.$refs.calendar.getApi()
      let date = calendarApi.getDate()
      let firstDay = this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
      let payload = {emp_id: this.$store.getters.empId,period:firstDay }
      AxiosCall.Get(payload, urlApi.project.combo).then(resp=>{
        if (resp.success){
          this.option_project = resp.atributes
        }
      })
    },
    formatDate(date) {
      let tgl = date.toLocaleString().split("T")

      let d = new Date(tgl[0]),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    onResize(){
      if (screen.width <= 770) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    locateMe(){
      let ini = this
      navigator.geolocation.getCurrentPosition((success)=>{
        let latitude = success.coords.latitude, longitude = success.coords.longitude
        ini.data.location = latitude+", "+longitude
      })
    },
    timeDiff(){
      let tgl = new Date()
      let ci = new  Date(tgl.getFullYear()+'-'+tgl.getMonth()+'-'+tgl.getDate()+" "+this.data.check_in)
      let co = new  Date(tgl.getFullYear()+'-'+tgl.getMonth()+'-'+tgl.getDate()+" "+this.data.check_out)

      let diff = co - ci
      return diff
    },
    getDetail(firstDay){
      let payload = {
        period : firstDay
      }
      AxiosCall.Get(payload, urlApi.time_recording.detail).then(res=>{
        if(res.success){
          this.detail= {stat_id :0}
          if(res.atributes.length > 0){
            this.detail = res.atributes[0]
          }

        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    checkAction(){
      for(let act in this.action_button){
        this.action_button[act] = Acl(this.$options.name, act)
        // console.log(act, Acl(this.$options.name, act))
      }
    }
  },
  mounted() {
    this.$store.state.events = []
    this.getData()
    this.getProject()
    for (let i = 1; i <= 8; i++) {
      this.option_hours.push({text: i + " h", value: i})
    }
    this.checkAction()
  },
  created() {
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})
  }
}
</script>

<style scoped>
  .calendar {
    flex: 1;
    padding: 2em;
  }

  .full-calendar{
    margin-bottom: 25px;
  }

  .he{
    height:6.5rem !important;
  }

  .fc-daygrid-event {
    white-space: normal !important;
  }
</style>
